import styled, { keyframes } from 'styled-components';

/* shimmer animation */
const shimmer = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #e2e4e8 25%, #d6d9de 37%, #e2e4e8 63%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: 6px;
`;

export const FormContainer = styled.div`
  margin-top: 24px;
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

/* Title */
export const TitleSkeleton = styled(SkeletonBase)`
  width: 180px;
  height: 24px;
  margin-bottom: 24px;
`;

/* Field */
export const FieldSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LabelSkeleton = styled(SkeletonBase)`
  width: 90px;
  height: 14px;
`;

export const InputSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 44px;
  border-radius: 8px;
`;

export const OfferCardSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 80px;
  margin-bottom: 50px;
`;


export const PhoneSkeleton = styled.div`
  position: relative;
  width: 100%;
`;

export const CountrySkeleton = styled(SkeletonBase)`
  position: absolute;
  left: 1px;
  top: 1px;
  bottom: 1px;
  width: 90px;
  border-radius: 6px 0 0 6px;
`;

export const PhoneInputSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 44px;
  padding-left: 100px;
  border-radius: 8px;
`;


export const InfoLinkSkeleton = styled(SkeletonBase)`
  width: 140px;
  height: 12px;
`;
